import API_URLS from '../../config/BackendConfig';
import { getToken } from '../../utils/tokenUtils';
import { postRequest } from '../../config/AxiosConfig';

const apiBaseUrlProd = API_URLS.PROD;




const getAuthHeaders = () => {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const createEquifax = async (payload, onAfterRequest = () => {}) => {
  try {
    const response = await postRequest({
      url: apiBaseUrlProd + "credit-report/equifax",
      headers: getAuthHeaders(),
      data: payload,
      onAfterRequest,
    });

    return response;
  } catch (error) {
    console.error(
      "Error creating equifax:",
      error.response?.data || error.message
    );
    throw error;
  }
};









